import { render, staticRenderFns } from "./turnPageAudio.vue?vue&type=template&id=161a2500&scoped=true"
import script from "./turnPageAudio.vue?vue&type=script&lang=js"
export * from "./turnPageAudio.vue?vue&type=script&lang=js"
import style0 from "./turnPageAudio.vue?vue&type=style&index=0&id=161a2500&prod&style=less&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "161a2500",
  null
  
)

export default component.exports